import clsx from "clsx";
import { FC, ReactNode, useEffect, useRef, useState } from "react";
import IconCross from "../../public/image/svg/cross.svg";
import styles from "./Dialog.module.scss";

export type Props = {
  children: ReactNode;
  className?: string;
  buttonClassName?: string;
  ariaLabel?: string;
  onClose?: () => void;
};

const Dialog: FC<Props> = ({
  onClose,
  className,
  buttonClassName,
  ariaLabel,
  children,
}) => {
  const dialogRef = useRef<HTMLDialogElement>(null);
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    const dialog = dialogRef.current;
    if (dialog && typeof dialog.showModal === "function") {
      dialog.showModal();

      setTimeout(() => setIsOpen(true), 0);
    }
    return () => {
      dialog?.close();
    };
  }, []);

  return (
    <dialog
      ref={dialogRef}
      className={clsx(styles.dialog, { [styles["dialog--open"]]: isOpen })}
      onCancel={(event) => {
        event.preventDefault();
        onClose?.();
      }}
      aria-modal
      aria-label={ariaLabel ? ariaLabel : "Modal"}
    >
      <div className={clsx(className, styles.content)}>
        <button
          aria-label="Close dialog"
          className={clsx(
            styles.close,
            buttonClassName,
            "btn btn-sm btn-circle btn-ghost absolute top-8 right-8"
          )}
          onClick={() => onClose?.()}
        >
          <IconCross />
        </button>
        {children}
      </div>
      <form method="dialog" className={styles.backdrop}>
        <button onClick={() => onClose?.()} aria-label="Close dialog">
          Close
        </button>
      </form>
    </dialog>
  );
};

export default Dialog;
